import { createTheme } from '@mui/material/styles';

// Global Tema Yapılandırması
const theme = createTheme({
  palette: {
    primary: {
      main: "#00A7B5",  // Turkuaz
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#1C355E",  // Lacivert
      contrastText: "#ffffff",
    },
    danger:{
      main: "#FF4343"
    }
    // Diğer renkleri ve tema özelleştirmelerini buraya ekleyebilirsiniz
  },
  typography: {
    // Yazı tipini buradan değiştirebilirsiniz
    fontFamily: '"Inter", sans-serif',
  },
  breakpoints: {
    values: {
      xs: 0,        // Mobil cihazlar (telefonlar)
      sm: 600,      // Küçük ekranlar (tabletler)
      md: 1200,     // Orta ekranlar (laptoplar)
      lg: 1700,     // Büyük ekranlar (masaüstü)
      xl: 2040,     // Çok büyük ekranlar (geniş ekranlar)
    }

  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          color: "#ffffff",
          "&:hover": {
            color: "#ffffff",
          },
          "& .MuiButton-startIcon, & .MuiButton-endIcon": {
            color: "#ffffff",
          },
        },
      },
    },
  },
});

export default theme;
